export default __webpack_public_path__ + "static/media/04a_folded.7e9ed9d0.png";